export const getPath = (location, path) => {
    const home = {
        location,
        path
    };
    return home;
};
